import React, { useCallback, useMemo, useState } from 'react';
import SearchField from '../../base/SearchField';
import FilterBar from '../index';
import useT from '../../../utils/Translations/useT';
const ResourceSelectorTreeFilters = ({ value, onChange, }) => {
    const t = useT();
    const [searchQuery, setSearchQuery] = useState(value === null || value === void 0 ? void 0 : value.searchQuery);
    const handleChange = useCallback(filters => onChange && onChange({ ...value, ...filters }), [onChange, value]);
    const handleSearchInputFocus = useCallback(searchContainerInput => {
        if (!searchContainerInput) {
            return;
        }
        const input = searchContainerInput.getElementsByTagName('input')[0];
        input && input.focus();
    }, []);
    const values = useMemo(() => ({ ...value, searchQuery }), [
        searchQuery,
        value,
    ]);
    return (<>
      <FilterBar searchName="searchQuery" values={values} onChange={handleChange}>
        <FilterBar.StatusWithDraftSelector name="status"/>
      </FilterBar>
      <div ref={handleSearchInputFocus}>
        <SearchField placeholder={t('Search')} value={searchQuery} onChange={setSearchQuery}/>
      </div>
    </>);
};
export default ResourceSelectorTreeFilters;
